/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const BabyGirlIconOutline = createIcon({
  displayName: 'BabyGirlIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <rect width="24" height="24"></rect>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.889 11.99l1.94473e-08-2.53352e-08c-.279242.363786-.708502.581175-1.167.591l7.31749e-08 2.00705e-09c-.457533-.0125492-.885382-.229409-1.166-.591"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M10.444 11.99l-1.46502e-08 1.90864e-08c-.279024.363516-.707856.580874-1.166.591l-5.20738e-08-1.40957e-09c-.457852-.0123935-.88607-.229255-1.167-.591"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14.222 16.144l6.30406e-08-5.4997e-08c-1.27314 1.11069-3.17086 1.11069-4.444 1.46263e-07"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.828 4.748l1.623-1.512 -1.76014e-08 1.6426e-08c.845502-.789038 2.17056-.743265 2.9596.102237 .0813244.087144.15506.181073.220402.280763l.154.233 -1.53941e-07-2.33891e-07c.380653.578348.583349 1.25563.583 1.948v0l5.99188e-08.000162707c.000238942.692051-.20249 1.36898-.58309 1.94697l-.155.233 -1.28658e-08 1.96783e-08c-.632252.967037-1.92873 1.23843-2.89577.606182 -.100619-.0657851-.195381-.140121-.283232-.222182l-1.62291-1.51314"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M10.172 6.85l-1.623 1.512 -2.49859e-08 2.33173e-08c-.845502.789038-2.17056.743265-2.9596-.102238 -.0813244-.087144-.15506-.181073-.220402-.280763l-.154-.233 2.41134e-08 3.66235e-08c-.380385-.577729-.583075-1.25429-.583-1.946v0l-8.71121e-08-.000784802c-1.04494e-07-.692034.202838-1.36889.583432-1.94687l.155-.233 5.12822e-08-7.83396e-08c.633103-.96714 1.93036-1.23793 2.8975-.604826 .0999656.0654389.194144.139317.281504.220826l1.623 1.512"
        ></path>
        <ellipse
          cx="12"
          rx="2.105"
          ry="2.126"
          cy="5.799"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></ellipse>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 21.47l1.32862e-07-6.99174e-11c3.75415-.00197568 7.04299-2.51519 8.031-6.137l6.41474e-08-7.12298e-09c1.21309-.134703 2.0873-1.22731 1.9526-2.4404 -.114087-1.02744-.925164-1.83851-1.9526-1.9526l-1.02167e-07-3.72633e-07c-.288586-1.05255-.781633-2.03797-1.451-2.9"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 21.47l1.31888e-07 6.94058e-11c-3.75415-.00197556-7.04299-2.51519-8.031-6.137l5.6717e-09 6.2979e-10c-1.21309-.134703-2.0873-1.22731-1.9526-2.4404 .114087-1.02744.925164-1.83851 1.9526-1.9526l-2.81934e-07 1.02829e-06c.288585-1.05255.781633-2.03797 1.451-2.9"
        ></path>
      </g>
    </>
  ),
})

const BabyGirlIconTwoTone = createIcon({
  displayName: 'BabyGirlIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <rect width="24" height="24"></rect>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.889 11.99l1.94473e-08-2.53352e-08c-.279242.363786-.708502.581175-1.167.591l7.31749e-08 2.00705e-09c-.457533-.0125492-.885382-.229409-1.166-.591"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M10.444 11.99l-1.46502e-08 1.90864e-08c-.279024.363516-.707856.580874-1.166.591l-5.20738e-08-1.40957e-09c-.457852-.0123935-.88607-.229255-1.167-.591"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14.222 16.144l6.30406e-08-5.4997e-08c-1.27314 1.11069-3.17086 1.11069-4.444 1.46263e-07"
        ></path>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.828 4.748l1.623-1.512 -1.76014e-08 1.6426e-08c.845502-.789038 2.17056-.743265 2.9596.102237 .0813244.087144.15506.181073.220402.280763l.154.233 -1.53941e-07-2.33891e-07c.380653.578348.583349 1.25563.583 1.948v0l5.99188e-08.000162707c.000238942.692051-.20249 1.36898-.58309 1.94697l-.155.233 -1.28658e-08 1.96783e-08c-.632252.967037-1.92873 1.23843-2.89577.606182 -.100619-.0657851-.195381-.140121-.283232-.222182l-1.62291-1.51314"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M10.172 6.85l-1.623 1.512 -2.49859e-08 2.33173e-08c-.845502.789038-2.17056.743265-2.9596-.102238 -.0813244-.087144-.15506-.181073-.220402-.280763l-.154-.233 2.41134e-08 3.66235e-08c-.380385-.577729-.583075-1.25429-.583-1.946v0l-8.71121e-08-.000784802c-1.04494e-07-.692034.202838-1.36889.583432-1.94687l.155-.233 5.12822e-08-7.83396e-08c.633103-.96714 1.93036-1.23793 2.8975-.604826 .0999656.0654389.194144.139317.281504.220826l1.623 1.512"
        ></Box>
        <Box
          as="ellipse"
          cx="12"
          rx="2.105"
          ry="2.126"
          cy="5.799"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 21.47l1.32862e-07-6.99174e-11c3.75415-.00197568 7.04299-2.51519 8.031-6.137l6.41474e-08-7.12298e-09c1.21309-.134703 2.0873-1.22731 1.9526-2.4404 -.114087-1.02744-.925164-1.83851-1.9526-1.9526l-1.02167e-07-3.72633e-07c-.288586-1.05255-.781633-2.03797-1.451-2.9"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 21.47l1.31888e-07 6.94058e-11c-3.75415-.00197556-7.04299-2.51519-8.031-6.137l5.6717e-09 6.2979e-10c-1.21309-.134703-2.0873-1.22731-1.9526-2.4404 .114087-1.02744.925164-1.83851 1.9526-1.9526l-2.81934e-07 1.02829e-06c.288585-1.05255.781633-2.03797 1.451-2.9"
        ></Box>
      </g>
    </>
  ),
})

const BabyGirl: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    case 'twoTone':
      return <CustomIcon as={BabyGirlIconTwoTone} {...props} />
    default:
      return <CustomIcon as={BabyGirlIconOutline} {...props} />
  }
}

export default memo(BabyGirl)
